export function waitUntil(check, execfunc, timeoutMs) {
  const timeWas = new Date();
  const wait = setInterval(function () {
    if (check()) {
      execfunc()
      clearInterval(wait);
    } else if (new Date() - timeWas > timeoutMs) { // Timeout
      clearInterval(wait);
    }
  }, 100);
}

export function getModelFromUri() {
  const path = window.location.pathname.split('/').filter(param => {
    return parseInt(param)
  })
  const model = [...path].pop();
  if (model === undefined) {
    return model
  }
  return [model.substring(0, model.length - 2), model.substring(model.length - 2, model.length + 1),]
}

export function getImageName(Article, color, view = "pdp", postfix = "") {
  const postfixcode = postfix ? '_' + postfix : "";
  if (!Article) {
    return "";
  }
  const ArtNr = typeof Article === "object" ? Article.article_nr : Article
  const ColorNr = typeof color === "object" ? color.color_nr : color
  return ArtNr + '_' + ColorNr + postfixcode + '-' + view + '.jpg'
}

export function preloadImages(baseUrl, Article) {
  const sizes = ["pdp","xsmall"]
  Article.colors.forEach(function (col) {
    const views = [""];
    if(col.hasMood) {
      views.push('MOOD')
    }
    if(col.hasFront) {
      views.push('FRNT')
    }
    sizes.forEach(function(size){
      views.forEach(function(view){
        const img = new Image()
        img.src = baseUrl + getImageName(Article, col, size, view)
      })
    })
  })

}

export function getLang(config) {
  const firstParam = window.location.pathname.split('/').filter(param => typeof param !== undefined && param !== "").shift()
  return config.language ? config.language : ['de','fr','es','en'].includes(firstParam) ? firstParam : 'de'
}

export function getItem(glassesList, articleNr) {


  return glassesList.filter(glass => {
      glass.article_nr === articleNr
    }
  )
}
